const ButtonRow = ({ children, alignment = 'center', extraClasses = '' }) => (
    <div className={`button-row ${alignment} ${extraClasses}`}>{children}</div>
);

export default ButtonRow;
